import request from '@webtrader/core/request';
import { checkIsNative } from '@webtrader/core/validators/device';

import { ILoginParams, ILoginResponse } from './types';

export interface IOMSLoginParams extends Omit<ILoginParams, 'userId'> {
  userId: number;
}

interface IOMSLoginResponse extends ILoginResponse {}

export default {
  demoLogin: (params: IOMSLoginParams) => {
    return checkIsNative()
      ? request.post<IOMSLoginResponse>('/api/auth/v2/company/demo/mobile/login', params)
      : request.post<IOMSLoginResponse>('/api/auth/v2/company/demo/login', params);
  },
  liveLogin: (params: IOMSLoginParams) => {
    return checkIsNative()
      ? request.post<IOMSLoginResponse>('/api/auth/v2/company/live/mobile/login', params)
      : request.post<IOMSLoginResponse>('/api/auth/v2/company/live/login', params);
  }
};
